import { useRef,useState,useContext,useEffect} from "react";
import { Toast } from "primereact/toast";
import { GeneralContext } from "../context/generalcontext";

export default function ToastComponent(){
    const {showAlert,setShowAlert,showDetail} = useContext(GeneralContext);
    const toast = useRef(null);

    const showSuccess = () => {
        toast.current.show({severity:'success', summary: 'Success', detail:showDetail??'success', life: 3000});
        setShowAlert(null);
    }

    const showError = () => {
        toast.current.show({severity:'error', summary: 'Error', detail:showDetail??'error', life: 3000});
        setShowAlert(null);
    }

    const showMultiple = ()=>{
        toast.current.show(showDetail);
        setShowAlert(null);
    }

    useEffect(()=>{
        switch (showAlert) {
            case 'success':
                showSuccess()
                break;
            case 'error':
                showError()
                break;
            case 'array':
                showMultiple()
                break;
        
            default:
                break;
        }        
    },[showAlert]);

    return(
        <Toast ref={toast} />
    )
}